var pdfMake = require("pdfmake/build/pdfmake.js");
var pdfFonts = require("pdfmake/build/vfs_fonts.js");
pdfMake.vfs = pdfFonts.pdfMake.vfs;

import { cond, trim } from "lodash";
import printJS from "print-js";
import QRCode from 'qrcode'

import JsBarcode from 'jsbarcode/bin/JsBarcode'


var textToBase64Barcode = function (text) {
  var canvas = document.createElement("canvas");
  JsBarcode(canvas, text, { format: "CODE128" });
  return canvas.toDataURL("image/png");
};

var formatNumero = function (val) {
  var mask = IMask.createMask({
    mask: Number,
    scale: 2,
    thousandsSeparator: ",",
    radix: ".",
  });

  mask.resolve(val.toString());
  return mask.value;
};

const ordenCombustible = (data) => {
  return new Promise(res => {
    const margin = {
      left: 20,
      right: 20
    };
    const lightGreen = "#a5ffc3"
    const subrayado = (string) => {
      return {
        margin: [0, -4.5, 0, 0],
        table: {
          widths: "*",
          heights: 5,
          body: [
            [{ text: string, border: [false, false, false, true] }]
          ]
        }
      }
    };
    const formatCaja = (string, color, height) => {
      return {
        layout: {
          fillColor: color ? color : ""
        },
        table: {
          widths: "*",
          heights: height ? height : 5,
          body: [
            [string]
          ]
        }
      }

    };
    var dd = {
      defaultStyle: {
        fontSize: 9,
      },
      styles: {
        boldcenter: {
          bold: true,
          alignment: "center"
        },
        boldright: {
          bold: true,
          alignment: "right"
        },

      },
      pageMargins: [margin.left, 110, margin.right, 30],
      header: function (currentPage, pageCount, pageSize) {
        return {
          margin: [margin.left, 30, margin.right, 0],
          columns: [
            {
              width: "22%",
              image: data.logo,
              fit: [100, 100],
              margin: [0, 0, 0, 0]
            },
            {
              width: "45%",
              bold: true,
              fontSize: 10,
              stack: [
                { text: `${data.desripEmpresa.trim()}`, fontSize: 13, color: "green" },
                { margin: [0, 2, 0, 0], text: `Nit: ${data.idEmpresa}` },
                { margin: [0, 2, 0, 0], text: `${data.ciudadEmpresa} - ${data.dptoEmpresa} ` }

              ]
            },

            {
              width: "*",
              margin: [20, 0, 0, 0],
              alignment: "center",
              fontSize: 10,
              stack: [
                {
                  table: {
                    widths: ["*"],
                    body: [
                      [{ text: "ORDEN COMBUSTIBLE", style: "boldcenter", fillColor: lightGreen }],
                      [{ text: `N° ${parseFloat(data.nro_rep)}`, alignment: "center", fontSize: 11, color: "red" }]
                    ]
                  }
                },
                { text: [{ text: "Fecha: ", bold: true }, data.fecha_rep], margin: [0, 5, 0, 0] }
              ]
            }
          ]
        }

      },
      content: [
        {
          columns: [
            {
              width: "65%",
              stack: [
                {
                  columns: [
                    { text: "PLACAS:", width: "auto" },
                    subrayado(data.placa_rep),
                    { text: "VEHICULO:", width: "auto" },
                    subrayado(data.vehiculo_rep.trim())
                  ]
                },

                {
                  margin: [0, 5, 0, 0],
                  columns: [
                    { text: "CONDUCTOR:", width: "auto" },
                    subrayado(data.nombre_conductor)
                  ]
                },
                {
                  margin: [0, 5, 0, 0],
                  columns: [
                    { text: "CELULAR:", width: "auto" },
                    subrayado(data.celular_rep),
                    { text: "NRO. ORDEN INTERNA:", width: "auto" },
                    subrayado(parseFloat(data.nrointerno_rep)),
                  ]
                },
                {
                  margin: [0, 5, 0, 0],
                  columns: [
                    { text: "PROPIETARIO:", width: "auto" },
                    subrayado(data.propietario_rep.trim())
                  ]
                },
                {
                  margin: [0, 5, 0, 0],
                  columns: [
                    { text: "TIPO COMBUSTIBLE:", width: "auto" },
                    subrayado(data.combustible_rep.trim()),
                    { text: "VALOR:", width: "auto" },
                    subrayado(data.valor_rep.trim()),
                  ]
                },

              ]
            },
            {
              margin: [10, 20, 0, 0],
              columns: [
                { text: "ORDEN DE COMPRA N°", width: "30%", bold: true, fontSize: 10 },
                { ...subrayado(parseFloat(data.ordenservic_rep)), margin: [0, 5, 0, 0] }
              ]
            },
          ]
        },
        {
          margin: [0, 30, 0, 0],
          columns: [
            {
              width: "48%",
              ...formatCaja({
                stack: [
                  { text: " ", margin: [0, 60, 0, 0] },
                  subrayado(" "),
                  { text: "DESPACHA: " + data.despacha_rep.trim(), alignment: "center", margin: [0, 3, 0, 0] }
                ]
              }, null, 100)
            },
            {
              width: "50%",
              margin: [5, 0, 0, 0],
              ...formatCaja({
                stack: [
                  { text: "FIRMA CONDUCTOR", margin: [0, 55, 0, 0], style: "boldcenter", color: "grey", fontSize: 14 },
                  subrayado(" "),
                  { text: `C.C. ${parseInt(data.idconductor_rep)}`, bold: true, margin: [0, 3, 0, 0] }
                ]
              }, null, 100)
            },
          ]
        },
        {
          style: "boldcenter",
          fontSize: 11,
          margin: [0, 3, 0, 0],
          text: `Cel: ${data.telefono} - Email: ${data.correo}`
        }
      ]

    }

    pdfMake.createPdf(dd).open();
    res();
  })
};
const CompEgreso = (data) => {
  return new Promise(res => {
    const margin = {
      left: 20,
      right: 20
    };
    const lightGreen = "#a5ffc3"
    const subrayado = (string) => {
      return {
        margin: [0, -4.5, 0, 0],
        table: {
          widths: "*",
          heights: 5,
          body: [
            [{ text: string, border: [false, false, false, true] }]
          ]
        }
      }
    };
    const formatCaja = (string, color, height) => {
      return {
        layout: {
          fillColor: color ? color : ""
        },
        table: {
          widths: "*",
          heights: height ? height : 5,
          body: [
            [string]
          ]
        }
      }

    };
    var dd = {
      defaultStyle: {
        fontSize: 9,
      },
      styles: {
        boldcenter: {
          bold: true,
          alignment: "center"
        },
        boldright: {
          bold: true,
          alignment: "right"
        },

      },
      pageMargins: [margin.left, 110, margin.right, 30],
      header: function (currentPage, pageCount, pageSize) {
        return {
          margin: [margin.left, 30, margin.right, 0],
          columns: [
            {
              width: "22%",
              image: data.logo,
              fit: [100, 100],
              margin: [0, 0, 0, 0]
            },
            {
              width: "45%",
              bold: true,
              fontSize: 10,
              stack: [
                { text: `${data.desripEmpresa.trim()}`, fontSize: 13, color: "green" },
                { margin: [0, 2, 0, 0], text: `Nit: ${data.idEmpresa}` },
                { margin: [0, 2, 0, 0], text: `${data.ciudadEmpresa} - ${data.dptoEmpresa} ` }

              ]
            },

            {
              width: "*",
              margin: [20, 0, 0, 0],
              alignment: "center",
              fontSize: 10,
              stack: [
                {
                  table: {
                    widths: ["*"],
                    body: [
                      [{ text: "COMPROBANTE DE EGRESO", style: "boldcenter", fillColor: lightGreen }],
                      [{ text: `N° ${parseFloat(data.nro_rep)}`, alignment: "center", fontSize: 11, color: "red" }]
                    ]
                  }
                },
                { text: [{ text: "Fecha: ", bold: true }, data.fecha_rep], margin: [0, 5, 0, 0] }
              ]
            }
          ]
        }

      },
      content: [
        {
          columns: [
            {
              width: "65%",
              stack: [
                {
                  columns: [
                    { text: "PLACAS:", width: "auto" },
                    subrayado(data.placa_rep),
                    { text: "VEHICULO:", width: "auto" },
                    subrayado(data.vehiculo_rep.trim())
                  ]
                },

                {
                  margin: [0, 5, 0, 0],
                  columns: [
                    { text: "CONDUCTOR:", width: "auto" },
                    subrayado(data.nombre_conductor)
                  ]
                },
                {
                  margin: [0, 5, 0, 0],
                  columns: [
                    { text: "CELULAR:", width: "auto" },
                    subrayado(data.celular_rep),
                    { text: "NRO. INTERNO:", width: "auto" },
                    subrayado(parseFloat(data.nrointerno_rep)),
                  ]
                },
                {
                  margin: [0, 5, 0, 0],
                  columns: [
                    { text: "PROPIETARIO:", width: "auto" },
                    subrayado(data.propietario_rep.trim())
                  ]
                },
                {
                  margin: [0, 5, 0, 0],
                  columns: [
                    { text: "VALOR:", width: "auto" },
                    subrayado(data.valor_rep.trim()),
                  ]
                },

              ]
            },
            {
              margin: [10, 20, 0, 0],
              columns: [
                { text: "ORDEN DE COMPRA N°", width: "30%", bold: true, fontSize: 10 },
                { ...subrayado(parseFloat(data.ordenservic_rep)), margin: [0, 5, 0, 0] }
              ]
            },
          ]
        },
        {
          margin: [0, 30, 0, 0],
          columns: [
            {
              width: "48%",
              ...formatCaja({
                stack: [
                  { text: " ", margin: [0, 60, 0, 0] },
                  subrayado(" "),
                  { text: "ELABORA: " + data.despacha_rep.trim(), alignment: "center", margin: [0, 3, 0, 0] }
                ]
              }, null, 100)
            },
            {
              width: "50%",
              margin: [5, 0, 0, 0],
              ...formatCaja({
                stack: [
                  { text: "FIRMA CONDUCTOR", margin: [0, 55, 0, 0], style: "boldcenter", color: "grey", fontSize: 14 },
                  subrayado(" "),
                  { text: `C.C. ${parseInt(data.idconductor_rep)}`, bold: true, margin: [0, 3, 0, 0] }
                ]
              }, null, 100)
            },
          ]
        },
        {
          style: "boldcenter",
          fontSize: 11,
          margin: [0, 3, 0, 0],
          text: `Cel: ${data.telefono} - Email: ${data.correo}`
        }
      ]

    }

    pdfMake.createPdf(dd).open();
    res();
  })
};
const remision = (data) => {
  return new Promise(res => {
    console.log(data);
    let material = "";

    material = window.atob(
      data.productos[0].base1_pr +
      data.productos[0].base2_pr +
      data.productos[0].base3_pr +
      data.productos[0].base5_pr
    );
    let volumen = data.productos[0].cantidad;

    const margin = {
      left: 20,
      right: 20
    };
    const lightGreen = "#a5ffc3"
    const subrayado = (string) => {
      return {
        margin: [0, -4.5, 0, 0],
        table: {
          widths: "*",
          heights: 5,
          body: [
            [{ text: string, border: [false, false, false, true] }]
          ]
        }
      }
    };
    const formatCaja = (string, color, height) => {
      return {
        layout: {
          fillColor: color ? color : ""
        },
        table: {
          widths: "*",
          heights: height ? height : 5,
          body: [
            [string]
          ]
        }
      }

    };
    var dd = {
      pageSize: {
        width: 612,
        height: 396
      },
      defaultStyle: {
        fontSize: 9,
      },
      styles: {
        boldcenter: {
          bold: true,
          alignment: "center"
        },
        boldright: {
          bold: true,
          alignment: "right"
        },

      },
      pageMargins: [margin.left, 80, margin.right, 10],
      header: function (currentPage, pageCount, pageSize) {
        return {
          margin: [margin.left, 10, margin.right, 0],
          columns: [
            {
              width: "18%",
              image: data.logo,
              fit: [80, 80],
              margin: [0, 0, 0, 0]
            },
            {
              width: "25%",
              bold: true,
              fontSize: 10,
              stack: [
                { text: data.nombre_empresa, fontSize: 13, color: "green" },
                { margin: [0, 2, 0, 0], text: `Nit: ${data.regimen_empresa} ${data.nit_empresa.trim()}` }
              ]
            },
            {
              width: "20%",
              table: {
                widths: "*",
                body: [
                  ["CÓDIGO:", "FR"],
                  ["VERSION:", "0.1"],
                  ["FECHA:", data.fecha]
                ]
              }
            },
            {
              width: "*",
              margin: [20, 0, 0, 0],
              alignment: "center",
              fontSize: 10,
              stack: [
                {
                  table: {
                    widths: ["*"],
                    body: [
                      [{ text: "REMISIÓN", style: "boldcenter", fillColor: lightGreen }],
                      [{ text: `N° ${data.numero_fact}`, alignment: "center", fontSize: 11, color: "red" }]
                    ]
                  }
                },
                {
                  text: [{ text: "Fecha: ", bold: true }, data.fecha_factura.trim()
                  ], margin: [0, 5, 0, 0]
                }
              ]
            }
          ]
        }

      },
      content: [
        {
          columns: [
            {
              width: "65%",
              stack: [
                {
                  columns: [
                    { text: "PLACAS:", width: "auto" },
                    subrayado(data.placa_pago),
                    { text: "VEHICULO:", width: "auto" },
                    subrayado(data.tipoveh_cliente)
                  ]
                },

                {
                  margin: [0, 5, 0, 0],
                  columns: [
                    { text: "MODELO:", width: "auto" },
                    subrayado(data.modelo_rem),
                    { text: "COLOR:", width: "auto" },
                    subrayado(data.color_rem)
                  ]
                },
                {
                  margin: [0, 5, 0, 0],
                  columns: [
                    { text: "CONDUCTOR:", width: "auto" },
                    subrayado(data.conductor_cliente)
                  ]
                },
                {
                  margin: [0, 5, 0, 0],
                  columns: [
                    { text: "CELULAR:", width: "auto" },
                    subrayado(data.telcond_cliente),
                    { text: "C.C:", width: "auto" },
                    subrayado(parseInt(data.idcond_cliente)),
                  ]
                },
                {
                  margin: [0, 5, 0, 0],
                  columns: [
                    { text: "MATERIAL:", width: "auto" },
                    subrayado(material),
                    { text: "FUENTE:", width: "auto" },
                    subrayado(data.productos[0].origen),
                  ]
                },
                {
                  margin: [0, 5, 0, 0],
                  columns: [
                    { text: "LUGAR DE DESCARGUE:", width: "auto" },
                    subrayado(data.productos[0].destino),
                    { text: "VOLUMEN:", width: "auto" },
                    subrayado(volumen),
                  ]
                },
                {
                  margin: [0, 5, 0, 0],
                  columns: [
                    { text: "RECIBO ACPM:", width: "auto" },
                    subrayado(data.rccombust_rem),
                    { text: "VALOR:", width: "auto" },
                    subrayado(data.combustible_rem),
                  ]
                },
                {
                  margin: [0, 5, 0, 0],
                  columns: [
                    { text: "RECIBO N.ANTICIPO:", width: "auto" },
                    subrayado(data.rcanticipo_rem),
                    { text: "VALOR:", width: "auto" },
                    subrayado(data.anticipo_rem),
                  ]
                },
              ]
            },
            {
              width: "*",
              margin: [5, 0, 0, 0],
              stack: [
                {
                  margin: [0, 0, 0, 6],
                  columns: [{ text: "ORDEN DE COMPRA N°", width: "30%", bold: true }, subrayado(data.orden_cliente)]
                },
                formatCaja({
                  stack: [
                    { text: "RECIBIDO CLIENTE", style: "boldcenter", margin: [0, 0, 0, 6] },
                    {
                      columns: [
                        { text: "CLIENTE:", width: "auto" },
                        subrayado,
                      ]
                    },
                    {
                      margin: [0, 5, 0, 0],
                      columns: [
                        { text: "HORA:", width: "auto" },
                        subrayado,
                        { text: "FECHA:", width: "auto" },
                        subrayado
                      ]
                    },
                    {
                      margin: [0, 5, 0, 0],
                      columns: [
                        { text: "KM DE DESCARGUE:", width: "auto" },
                        subrayado,
                      ]
                    },
                  ]
                }, lightGreen)

              ]
            }
          ]
        },
        { text: "Nro Orden interna: " + data.orden_interna, bold: true, fontSize: 11, margin: [0, 3, 0, 8] },
        {
          columns: [
            {
              width: "63%",
              stack: [
                { style: "boldcenter", text: "ESTE DOCUMENTO SE ASEMEJA A UN TITULO VALOR, SU PERDIDO O MAL DILIGENCIAMIENTO IMPLICA EL NO PAGO DEL TRANSPORTE - NO SE ACEPTAN COPIAS NI ENMENDADURAS", color: "green" },
                {
                  margin: [0, 10, 0, 0],
                  columns: [
                    {
                      width: "48%",
                      ...formatCaja({
                        stack: [
                          { text: " ", margin: [0, 30, 0, 0] },
                          subrayado(" "),
                          { text: "DESPACHA", alignment: "center", margin: [0, 3, 0, 0] }
                        ]
                      }, null, 70)
                    },
                    {
                      width: "50%",
                      margin: [5, 0, 0, 0],
                      ...formatCaja({
                        stack: [
                          { text: "TRANSPORTA", bold: true },
                          { text: "FIRMA CONDUCTOR", margin: [0, 25, 0, 0], style: "boldcenter", color: "grey", fontSize: 14 },
                          subrayado(" "),
                          { text: "C.C. " + data.idcond_cliente, bold: true, margin: [0, 3, 0, 0] }
                        ]
                      }, null, 70)
                    },
                  ]
                },
                {
                  bold: true,
                  margin: [0, 3, 0, 0],
                  text: `PBX: 682 43 52 - Cel: 320 310 65 37 - Email: grupoempresarialjaelfa@gmail.com`
                }
              ]
            },
            {
              margin: [5, 0, 0, 0],
              stack: [
                formatCaja({
                  stack: [

                    { text: "FIRMA Y SELLO QUIEN RECIBE", margin: [0, 15, 0, 0], style: "boldcenter", color: "grey", fontSize: 12 },
                    subrayado(" "),
                    { text: "NOMBRE LEGIBLE Y SELLO QUIEN RECIBIO", style: "boldcenter", margin: [0, 3, 0, 0] },
                    { text: "C.C", bold: true }
                  ]
                }, lightGreen, 70),
                {
                  fontSize: 8,
                  margin: [0, 2, 0, 0],
                  text: "LA FIRMA PUESTA POR TERCEROS EN REPRESENTACIÓN MANDATO U OTRA CALIDAD SIMILAR A NOMBRE DEL COMPRADOR IMPLICA SU OBLIGACIÓN (ART. 640 DEL CÓDIGO DE COMERCIO)"
                },
                { ...subrayado(" "), margin: [0, -6, 0, 0] },
                { text: "-ORIGINAL-\nGRUPO EMPRESARIAL JAELFA", margin: [0, 1, 0, 0], style: "boldcenter" }
              ]
            }
          ]
        }
      ]

    }

    pdfMake.createPdf(dd).open();
    res();
  })
};

const ordensal_sar = (data) => {
  return new Promise(res => {
    let stylePDF = {
      pageSize: {
        width: 200,
        height: "auto",
      },
      pageMargins: [20, 10, 10, 10],
    };

    let linea = {
      text:
        "------------------------------------------",
      bold: true,
      fontSize: 12,
    };
    let tipo = (data.tipo_rep == "1") ? "DESPACHO S.A.R." :
      (data.tipo_rep == "2") ? "ORDEN DE SALIDA" :
        "ORDEN DE DESPACHO";

    var dd = {
      ...stylePDF,
      content: [
        {
          stack: [
            {
              columns: [
                {
                  image: data.logo,
                  width: 80,
                  height: 40,
                },
                {
                  image: data.logoSuper,
                  width: 80,
                  height: 40,
                },
              ],
            },
          ],
        },
        { ...linea },
        {
          margin: [10, 5, 10, 0],
          stack: [{ text: tipo }],
          style: "header",
        },
        { ...linea },
        {
          columns: [

            {
              style: "subtitles",
              stack: [
                "NÚMERO:",
                "ORIGEN:",
                " ",
                "DESTINO:",
                " ",
                "HORA:"
              ]
            },
            {
              style: "contenido1",
              stack: [
                { text: parseFloat(data.nro_rep), bold: true },
                `${parseFloat(data.codorig_rep)} - ${data.descrorig_rep.trim()}\n`,
                `${parseFloat(data.coddest_rep)} - ${data.descrdest_rep.trim()}\n\n`,
                data.hora_rep,
              ]
            },
          ],
        },
        { ...linea },

        {
          columns: [
            {
              style: "subtitles",
              stack: [
                "VEHÍCULO:",
                "NRO_INTERNO:",
                "CONDUCTOR:",
                "PREOPERACIONAL:",
              ]
            },
            {
              style: "right",
              stack: [
                data.placa_rep,
                { text: parseFloat(data.interno_rep), bold: true },
                parseFloat(data.idconductor_rep),
                " ",
              ]
            }
          ]
        },
        { ...linea },
      ],
      styles: {
        header: {
          bold: true,
          fontSize: 15,
          alignment: "center"
        },
        contenido1: {
          fontSize: 10,
          alignment: "left",
        },
        subtitles: {
          bold: true,
          fontSize: 10,
        },
        right: {
          alignment: "right",
          fontSize: 10
        }
      }
    };


    const pdfDocGenerator = pdfMake.createPdf(dd);
    pdfDocGenerator.getBlob((blob) => {
      printJS({
        printable: URL.createObjectURL(blob),
        onPrintDialogClose: () => {
          res();
        }
      })
    })



    // pdfMake.createPdf(dd).open();
    // res();




  })
};

const recibo_caja = (data) => {
  return new Promise(res => {
    let stylePDF = {
      pageSize: {
        width: 200,
        height: "auto",
      },
      pageMargins: [20, 10, 10, 10],
    };
    let watermark =
    {
      text: data.marca_agua,
      angle: 60,
      color: "black",
      opacity: 0.2,
      fontSize: 70,
    };

    let linea = {
      text:
        "------------------------------------------",
      bold: true,
      fontSize: 12,
    };

    const objRegistros = []
    let totalRegistros = 0
    data.registros.forEach(item => {
      objRegistros.push({
        margin: [0, 10, 0, 0],
        columns: [
          {
            width: '35%',
            style: "contenido1",
            fontSize: 9,
            table: {
              widths: [100],
              body: [
                [{ text: "Id:", bold: true, alignment: "left" }],
                [{ text: "Concepto:", bold: true, alignment: "left" }],
                [{ text: "Detalle:", bold: true, alignment: "left" }],
                [{ text: "Valor:", bold: true, alignment: "left" }]
              ]
            },
            layout: {
              hLineWidth: function (i, node) {
                return 0;
              },
              vLineWidth: function (i, node) {
                return 0;
              },
            }
          },
          {
            style: "contenido1",
            fontSize: 9,
            table: {
              widths: [100],
              body: [
                [{ text: parseFloat(item.idrut), alignment: "left" }],
                [{ text: item.concepto.trim(), alignment: "left" }],
                [{ text: item.detalle.trim() || '\n', alignment: "left" }],
                [{ text: "$" + item.valor.trim(), alignment: 'left', fontSize: 8 }]
              ]
            },
            layout: {
              hLineWidth: function (i, node) {
                return 0;
              },
              vLineWidth: function (i, node) {
                return 0;
              },
            }
          }
          // {
          //   style: "contenido1",
          //   fontSize: 7,              
          //   stack: [
          //     { text: parseFloat(item.idrut), alignment: "left" },
          //     { text: item.concepto.trim(), alignment:'left'},               
          //     { text: item.detalle.trim() || '\n', alignment:'left'},               
          //     //{ text: item.detalle.trim() || '\n', alignment:'left'},               
          //     { text: "$" + item.valor.trim(), alignment:'left', fontSize: 8},
          //     " "
          //   ]
          // }
        ]
      })

      totalRegistros += parseFloat(item.valor.replace(/\,/g, "")) || 0
    })

    objRegistros.push({
      columns: [
        {
          text: "\nTotal: ",
          bold: true,
          fontSize: 12
        },
        { text: "\n $" + formatNumero(totalRegistros), alignment: 'left', fontSize: 12, bold: true, },
      ]
    })

    var dd = {
      watermark,
      ...stylePDF,
      content: [
        {
          stack: [
            {
              columns: [
                {
                  image: data.logo,
                  width: 80,
                  height: 40,
                },
                {
                  image: data.logoSuper,
                  width: 80,
                  height: 40,
                },
              ],
            },
          ],
        },
        { ...linea },
        {
          margin: [10, 5, 10, 0],
          text: data.tipo === "001" ? "RECIBO PROVISIONAL DE CAJA" : "COMPROBANTE DE EGRESO",
          fontSize: 10,
          bold: true
        },
        { ...linea },
        {
          columns: [
            {
              width: '40%',
              style: "subtitles",
              stack: [
                { text: "NÚMERO:", bold: true },
                "Fecha:",
                "Taquilla:",
                " ",
                " ",
                "Placa:",
                "Nro interno:",
                "Detalle Ppal:"
              ]
            },
            {
              style: "contenido1",
              fontSize: 9,
              stack: [
                { text: parseFloat(data.consecutivo), bold: true, alignment: "left" },
                { text: data.fecha.trim(), alignment: 'left' },
                { text: data.descrip_agc.trim(), alignment: 'left' },
                { text: " " },
                { text: data.registros[0].placa, alignment: 'left' },
                { text: data.registros[0].nrointerno.trim(), alignment: 'left' },
                { text: data.detallegral.trim(), alignment: 'left' },
              ]
            },
          ],
        },
        { ...linea },


        ...objRegistros,
        { ...linea },
        {
          columns: [
            {
              style: "subtitles",
              stack: [
                data.tipo === "001" ? "Recibido por:" : "Elaborado por:",
                " ",
                " ",
                "Hora:",
              ]
            },
            {
              style: "contenido1",
              fontSize: 9,
              stack: [
                { text: data.descrelabora.trim(), alignment: 'left' },
                { text: " " },
                { text: data.hora.trim(), alignment: 'left' },
              ]
            },
          ]
        },
        { ...linea },

      ],
      styles: {
        header: {
          bold: true,
          fontSize: 15,
          alignment: "center"
        },
        contenido1: {
          fontSize: 10,
          alignment: "left",
        },
        subtitles: {
          bold: true,
          fontSize: 10,
        },
        right: {
          alignment: "right",
          fontSize: 10
        }
      }
    };
    const pdfDocGenerator = pdfMake.createPdf(dd);
    pdfDocGenerator.getBlob((blob) => {
      printJS({
        printable: URL.createObjectURL(blob),
        onPrintDialogClose: () => {
          res();
        }
      })
    })
  });

  //   pdfMake.createPdf(dd).open();
  //   res();
  // })
};

const tiquete_transporte = async (data, fecha, hora) => {
  let url = " ";
  url = "https://catalogo-vpfe.dian.gov.co/document/searchqr?documentkey=" + data.iddian_tiq
  let qr = await QRCode.toDataURL(url);


  let watermark =
    data.estado_tiq === "0"
      ? ""
      : {
        text: "Anulado",
        angle: 60,
        color: "black",
        opacity: 0.2,
        fontSize: 100,
      };
  let tiquete = parseFloat(data.nro_tiq);
  let nrodian = "DETP" + parseFloat(data.nrodian_tiq);
  let fechaelabora = parseFloat(data.fechaelab_tiq);
  let nroint = parseFloat(data.nrointer_tiq);
  let agencia = data.descagencia_tiq;
  let taquillero = data.taquillero_tiq;
  let nroPasajeros = data.pasajeros.length;
  let destino = data.destino_tiq.trim();
  let total = 0;
  let idPas = [];
  let nombres = [];
  let dcto = 0;
  let bruto = 0;
  let stylePDF = {
    pageSize: {
      width: 200,
      height: "auto",
    },
    pageMargins: [20, 10, 10, 10],
  };

  data.pasajeros = data.pasajeros.filter(item => item.idpasajero_tiq);
  data.pasajeros.forEach((pa) => {
    pa.idpasajero_tiq = pa.idpasajero_tiq.trim();
    idPas.push(parseFloat(pa.idpasajero_tiq));
    nombres.push(pa.nombrepasajero_tiq.trim() + "\n");
    dcto += parseFloat(pa.dcto_tiq.replace(/\,/g, ""));
    bruto += parseFloat(pa.vlrbruto_tiq.replace(/\,/g, ""));

    total += parseFloat(pa.vlrneto_tiq.replace(/\,/g, "")) || 0;
  });

  let linea = {
    text:
      "--------------------------------------------------------",
    bold: true,
    fontSize: 8,
  };

  let sillas = data.pasajeros.map(item => item.silla_tiq)
  return new Promise((res) => {
    let formapago = "";

    switch (data.pasajeros[0].formapago_tiq) {
      case "01":
        formapago = "Efectivo";
        break;
      case "02":
        formapago = "Tarjeta crédito";
        break;
      case "03":
        formapago = "Débito/Qr.";
        break;
      case "04":
        formapago = "Otro";
        break;
      case "06":
        formapago = "Yates";
        break;
      case "07":
        formapago = "Redbus";
        break;
      case "08":
        formapago = "Reserva";
        break;
      case "09":
        formapago = "Convenio Brasilia";
        break;
      case "10":
        formapago = "Pin Bus";
        break;
      case "11":
        formapago = "Gamarra";
        break;

    }

    var dd = {
      watermark,
      ...stylePDF,
      content: [
        { text: `${fecha} ${hora}\n\n`, fontSize: 3 },
        {
          stack: [
            {
              columns: [
                {
                  image: data.logo,
                  width: 100,
                  height: 50,
                },
                {
                  image: data.logoSuper,
                  width: 100,
                  height: 50,
                },
              ],
            },
          ],
        },
        {
          stack: [{ text: "TAX META S.A" }, { text: "Nit. 892000113 - 0" }],
          style: "titulo1",
        },
        {
          stack: [{ text: "TIQUETE TRANSPORTE DE PASAJEROS" }],
          style: "titulo2",
        },

        {
          stack: [
            {
              text:
                "Documento equivalente a factura de venta Art5. Decreto 1165 - 1996 Póliza No 1003610861004",
            },
            { text: "Seguros Comerciales Bolivar SA" },
          ],
          style: "titulo3",
        },

        (data.iddian_tiq) ? {
          width: 110,
          margin: [30, 0, 0, 0],
          image: qr,
        } : {},

        { ...linea },
        { text: "ORIGINAL", style: "center" },
        { ...linea },
        {
          columns: [
            {
              stack: [
                "Consecutivo Dian: ",
                "Nro:",
                "Taquilla:",
                "Vendedor:",
                " ",
                "Expedición:",
                "Origen:",
                " ",
                "Destino:",
                " ",
                "Fecha viaje:",
                "Hora sala:",
              ],
              style: "contenido1",
            },
            {
              stack: [
                { text: `${nrodian}\n`, bold: true },
                { text: `${tiquete}\n`, bold: true, alignment: "left", },
                { text: `${agencia}\n`, fontSize: 8, alignment: "left", },
                { text: `${taquillero}`, fontSize: 8, alignment: "left", },
                { text: `${data.fechaelab_tiq}` + " Hora:" + `${data.horaelab_tiq}`, fontSize: 8, alignment: "left", },
                `${data.origen_tiq.trim()}\n`,
                `${destino}\n\n`,
                `${data.fechaemb_tiq}`,
                `${data.horaemb_tiq}\n\n`,
              ],
              style: "contenido2",
            },
          ],
        },
        {
          text: "Vehículo:" + `${nroint} - ${data.placa_tiq}\n\n`,
          fontSize: 12,
          alignment: "center",
          bold: true,
        },
        {
          columns: [
            {
              stack: [
                "Servicio:",
                "Pasajeros:",
                "Sillas:",
                "Cliente:",
                ...idPas,
              ],
              style: "contenido3",
            },
            {
              stack: [
                "\n",
                `${nroPasajeros}\n`,
                { text: `${sillas.join(',')}\n`, bold: true },
                "\n",
                ...nombres,
              ],
              style: "contenido2",
            },
          ],
        },
        { ...linea },
        {
          columns: [
            {
              stack: [
                "Forma de pago:",
                "Valor Tiquete:",
                "Descuento:",
                { text: "TOTAL:", fontSize: 12, bold: true },
              ],
              style: "contenido3",
            },
            {
              stack: [
                `${formapago}\n`,
                `$${formatNumero(bruto) || "00"}\n`,
                `$${formatNumero(dcto) || "00"}\n`,
                { text: `${formatNumero(total)}\n`, fontSize: 12, bold: true },
                // `$ ${formatNumero(total)}\n`,
              ],
              style: "contenido2",
            },
          ],
        },
        {
          stack: [
            { text: "Condiciones de viaje:", bold: true },
            "En caso de daño imprevisto del vehículo al presentarse cualquier inconveniente en la vía,el conductor hará lo posible para que los pasajeros puedan continuar el viaje, la empresa no asume responsabilidad por perjuicios ocasionados por esta causa.",
            "El pasajero declara conocer las condiciones de la empresa y asume la responsabilidad y riesgo del transporte",
            "- Todo pasajero tiene derecho a llevar 15 kilos de equipaje pero la empresa no se responsabiliza por el contenido,perdida o cambios de maletas u otros objetos.",
            "- Pasajero que no se presenta a la hora de salida perderá el valor del pasaje",
            "- Si su equipaje contiene objetos de valor deberá aforarlos",
            "- Si lleva equipaje reclame su sticker.",
            "Vigilado superintendencia de Puertos y Transporte",
          ],
          style: "pie1",
          margin: [0, 10, 0, 0],
        },
        { text: `CUFE: : ${data.iddian_tiq}`, margin: [0, 10, 0, 0], fontSize: 6, style: "contenido3", },
        { ...linea },
        {
          stack: [
            "Calle 38 32-41 - Villavicencio",
            "310.563.5045",
            // { text: `${tiquete}\n`, bold: true },
            "Fabricante y nombre del software:",
            "TITAN SOLUCIONES SAS",
            "901.289.171",
          ],
          style: "pie2",
        },
      ],
      styles: {
        titulo1: {
          fontSize: 14,
          alignment: "center",
          bold: true,
        },
        titulo2: {
          fontSize: 10,
          alignment: "center",
          bold: true,
        },
        titulo3: {
          fontSize: 8,
          alignment: "center",
        },
        contenido1: {
          fontSize: 10,
          alignment: "left",
        },
        contenido2: {
          fontSize: 10,
          alignment: "right",
        },

        contenido3: {
          fontSize: 10,
          alignment: "left",
        },

        pie1: {
          fontSize: 8,
          alignment: "center",
        },

        pie2: {
          fontSize: 8,
          alignment: "center",
        },

        center: {
          fontSize: 14,
          alignment: "center",
        },

        right: {
          fontSize: 16,
          alignment: "right",
        },
      },
      defaultStyle: {
        fontSize: 8,
      },
    };

    const pdfDocGenerator = pdfMake.createPdf(dd);
    pdfDocGenerator.getBlob((blob) => {
      printJS({
        printable: URL.createObjectURL(blob),
        onPrintDialogClose: async () => {
          var dd = {
            watermark,
            content: [
              { text: `${fecha} ${hora}\n\n`, fontSize: 10 },
              { ...linea },
              {
                columns: [
                  {
                    stack: [
                      "Número tiquete:",
                      "Forma Pago",
                      "Taquilla:",
                      "Vehículo:",
                      "Destino:",
                      " ",
                      " ",
                      "Valor:",
                      "  ",
                      "  ",
                      "Pasajeros:",
                      ...idPas,

                    ],
                    fontSize: 8,
                  },
                  {
                    stack: [
                      " ",
                      " ",
                      " ",
                      " ",
                      " ",
                      " ",
                      " ",
                      " ",
                      " ",
                      " ",
                      " ",
                      " ",
                      { text: `${nombres}\n`, fontSize: 8, alignment: "left", },
                    ],
                    fontSize: 8,
                  },

                  {
                    stack: [
                      { text: `${tiquete}\n`, bold: true },
                      { text: `${formapago}\n`, bold: false },
                      { text: `${agencia}\n`, fontSize: 6, alignment: "left", },
                      `${nroint}\n`,
                      `${destino}\n\n`,
                      `$ ${formatNumero(total)}\n\n\n`,
                      // `\n${nombres}\n`,
                      " ",
                      `${nroPasajeros}\n`,
                    ],
                    style: "right",
                  },
                  {
                    stack: [
                      " ",
                    ],
                    fontSize: 8,
                  },

                ],
              },
              { ...linea },
            ],
            styles: {
              center: {
                fontSize: 6,
                alignment: "center",
              },
              right: {
                fontSize: 10,
                alignment: "right",
              },
            },
            pageSize: {
              width: 200,
              height: "auto",
            },
            defaultStyle: {
              fontSize: 8,
            },

            pageMargins: [10, 10, 0, 10],
          };


          await new Promise(r => setTimeout(r, 1000));
          const pdfDocGenerator = pdfMake.createPdf(dd);
          pdfDocGenerator.getBlob((blob2) => {
            printJS({
              printable: URL.createObjectURL(blob2),
              onPrintDialogClose: () => {
                res();
              },
            });
          });
        },
      });
    });
  });
};
const cuadre_cajatr = (data) => {
  return new Promise((res) => {
    let stylePDF = {
      pageSize: {
        width: 200,
        height: "auto",
      },
      pageMargins: [20, 10, 10, 10],
    };
    let ventas = parseFloat(data.ventas_cua.replace(/\,/g, "")) || 0;
    let seguro = parseFloat(data.seguro_cua.replace(/\,/g, "")) || 0;
    let rpc = parseFloat(data.rpc_cua.replace(/\,/g, "")) || 0;
    let egresos = parseFloat(data.egresos_cua.replace(/\,/g, "")) || 0;
    let avances = parseFloat(data.avances_cua.replace(/\,/g, "")) || 0;

    let tdebito = parseFloat(data.tdebito_cua.replace(/\,/g, "")) || 0;
    let saldo = parseFloat(data.saldoini_cua.replace(/\,/g, "")) || 0;

    let totalcuadre = ventas + rpc - egresos + seguro - avances + saldo - tdebito

    let cant100 = parseFloat(data.cant100_cua.replace(/\,/g, "")) || 0;
    let vlr100 = cant100 * 100000;
    let cant50 = parseFloat(data.cant50_cua.replace(/\,/g, "")) || 0;
    let vlr50 = cant50 * 50000;
    let cant20 = parseFloat(data.cant20_cua.replace(/\,/g, "")) || 0;
    let vlr20 = cant20 * 20000;
    let cant10 = parseFloat(data.cant10_cua.replace(/\,/g, "")) || 0;
    let vlr10 = cant10 * 10000;
    let cant5 = parseFloat(data.cant5_cua.replace(/\,/g, "")) || 0;
    let vlr5 = cant5 * 5000;
    let cant2 = parseFloat(data.cant2_cua.replace(/\,/g, "")) || 0;
    let vlr2 = cant2 * 2000;
    let cant1 = parseFloat(data.cant1_cua.replace(/\,/g, "")) || 0;
    let vlr1 = cant1 * 1000;
    let vlrmon = parseFloat(data.vlrmonedas_cua.replace(/\,/g, "")) || 0;

    let totalefectivo = vlr100 + vlr50 + vlr20 + vlr10 + vlr5 + vlr2 + vlr1 + vlrmon
    let diferencia = totalcuadre - totalefectivo

    let get_row = (label, value) => {
      return {
        columns: [
          { text: label + ': ' },
          { text: value }
        ]
      }
    }
    let layout = {
      vLineColor: "#A4A4A4",
      hLineColor: "#A4A4A4",
      hLineWidth: function (i, node) {
        return 0.3;
      },
      vLineWidth: function (i, node) {
        return 0.3;
      },
    };

    var dd = {
      ...stylePDF,
      content: [
        {
          fontSize: 6.5,
          headerRows: 1,
          table: {
            widths: ["auto", "auto", "auto", "auto", "auto", "auto", "auto"],
            body: [
              [
                {
                  colSpan: 7,
                  image: data.logo,
                  fit: [100, 100],
                  alignment: "center",
                  margin: [0, 2],
                },
                "", "", "", "", "", "",
              ],
              [
                {
                  fontSize: 10,
                  colSpan: 7,
                  text: [
                    { text: "Cierre de Caja:  ", bold: true },
                    parseInt(data.nro_cua.trim()),
                  ],
                  style: "center",
                  margin: [0, 2],
                },
                "", "", "", "", "", "",
              ],
              [
                {
                  fontSize: 10,
                  colSpan: 4,
                  text: [
                    { text: "Fecha Caja:  ", style: "center" },
                    data.fecha_cua,
                  ],
                },
                "", "", "",
                {
                  fontSize: 10,
                  colSpan: 3,
                  text: [
                    { text: "Turno:  ", style: "center" },
                    data.turno_cua
                  ],
                },
                "", "",
              ],
              [
                {
                  colSpan: 7,
                  text: [
                    "Despachador: ",
                    { text: data.taquillero_cua.trim(), bold: true },
                  ],
                  fontSize: 8,
                },
                "",
                "",
                "",
                "",
                "",
                "",
              ],
              [
                {
                  fontSize: 10,
                  colSpan: 7,
                  text: [
                    { text: "Tiquete Inicial:  ", bold: true },
                    parseInt(data.tiqini_cua.trim()),
                  ],
                },
                "", "", "", "", "", "",
              ],
              [
                {
                  fontSize: 10,
                  colSpan: 7,
                  text: [
                    { text: "Tiquete Final:  ", bold: true },
                    parseInt(data.tiqfin_cua.trim()),
                  ],
                },
                "", "", "", "", "", "",
              ],
              [
                {
                  fontSize: 10,
                  colSpan: 7,
                  text: [
                    { text: "Ingresos Intermunicipales", fontSize: 10, bold: true, style: "center" },

                  ],
                },
                "", "", "", "", "", "",
              ],

              [
                {
                  fontSize: 8,
                  colSpan: 4,
                  text: [
                    { text: "CONCEPTO:  ", style: "center", bold: false },
                  ],
                },
                "", "", "",
                {
                  fontSize: 8,
                  colSpan: 3,
                  text: [
                    { text: "VALOR", style: "center", bold: false },
                  ],
                },
                "", "",
              ],
              [
                { colSpan: 4, text: "Saldo Inicial", style: "left", fontSize: 8 },
                "",
                "",
                "",
                {
                  colSpan: 3,
                  text: "$ " + formatNumero(data.saldoini_cua.trim() || 0),
                  fontSize: 8,
                  alignment: "right",
                },
                "",
                "",
              ],
              [
                { colSpan: 4, text: "Ventas", style: "left", fontSize: 8 },
                "",
                "",
                "",
                {
                  colSpan: 3,
                  text: "$ " + formatNumero(data.ventas_cua.trim() || 0),
                  fontSize: 8,
                  alignment: "right",
                },
                "",
                "",
              ],

              [
                { colSpan: 4, text: "Seguro", style: "left", fontSize: 8 },
                "",
                "",
                "",
                {
                  colSpan: 3,
                  text: "$ " + formatNumero(data.seguro_cua.trim() || 0),
                  fontSize: 8,
                  alignment: "right",
                },
                "",
                "",
              ],
              [
                { colSpan: 4, text: "RPC", style: "left", fontSize: 8 },
                "",
                "",
                "",
                {
                  colSpan: 3,
                  text: "$ " + formatNumero(data.rpc_cua.trim() || 0),
                  fontSize: 8,
                  alignment: "right",
                },
                "",
                "",
              ],

              [
                { colSpan: 4, text: "Egresos", style: "left", fontSize: 8 },
                "",
                "",
                "",
                {
                  colSpan: 3,
                  text: "$ " + formatNumero(data.egresos_cua.trim() || 0),
                  fontSize: 8,
                  alignment: "right",
                },
                "",
                "",
              ],
              [
                { colSpan: 4, text: "Avances", style: "left", fontSize: 8 },
                "",
                "",
                "",
                {
                  colSpan: 3,
                  text: "$ " + formatNumero(data.avances_cua.trim() || 0),
                  fontSize: 8,
                  alignment: "right",
                },
                "",
                "",
              ],

              [
                { colSpan: 4, text: "Redbus", style: "left", fontSize: 8 },
                "",
                "",
                "",
                {
                  colSpan: 3,
                  text: "$ " + formatNumero(data.redbus_cua.trim() || 0),
                  fontSize: 8,
                  alignment: "right",
                },
                "",
                "",
              ],
              [
                { colSpan: 4, text: "Pinbus", style: "left", fontSize: 8 },
                "",
                "",
                "",
                {
                  colSpan: 3,
                  text: "$ " + formatNumero(data.pinbus_cua.trim() || 0),
                  fontSize: 8,
                  alignment: "right",
                },
                "",
                "",
              ],
              [
                { colSpan: 4, text: "TDebito/Qr", style: "left", fontSize: 8 },
                "",
                "",
                "",
                {
                  colSpan: 3,
                  text: "$ " + formatNumero(data.tdebito_cua.trim() || 0),
                  fontSize: 8,
                  alignment: "right",
                },
                "",
                "",
              ],
              [
                {
                  colSpan: 4,
                  text: "Total Cierre de Caja",
                  style: "right",
                  fontSize: 10,
                },
                "",
                "",
                "",
                {
                  colSpan: 3,
                  text: "$ " + formatNumero((totalcuadre) || 0),
                  fontSize: 8,
                  alignment: "right",
                },
                "",
                "",

              ],
              [
                {
                  fontSize: 10,
                  colSpan: 7,
                  text: [
                    { text: "Efectivo Entregado", fontSize: 10, bold: true, style: "center" },

                  ],
                },
                "", "", "", "", "", "",
              ],

              [
                {
                  fontSize: 8,
                  colSpan: 3,
                  text: [
                    { text: "Denominación", style: "center", bold: false },
                  ],
                },
                "", "",
                {
                  fontSize: 8,
                  colSpan: 2,
                  text: [
                    { text: "Cant", style: "center", bold: false },
                  ],
                },
                "",
                {
                  fontSize: 8,
                  colSpan: 2,
                  text: [
                    { text: "Total", style: "center", bold: false },
                  ],
                },
                "",
              ],

              [
                {
                  fontSize: 8,
                  colSpan: 3,
                  text: [
                    { text: "$100.000", style: "center", bold: false },
                  ],
                },
                "", "",
                {
                  colSpan: 2,
                  text: formatNumero(cant100),
                  fontSize: 8,
                  alignment: "right",
                },
                "",
                {
                  colSpan: 2,
                  text: "$ " + formatNumero(vlr100),
                  fontSize: 8,
                  alignment: "right",
                },
                "",
              ],
              [
                {
                  fontSize: 8,
                  colSpan: 3,
                  text: [
                    { text: "$50.000", style: "center", bold: false },
                  ],
                },
                "", "",
                {
                  colSpan: 2,
                  text: formatNumero(cant50),
                  fontSize: 8,
                  alignment: "right",
                },
                "",
                {
                  colSpan: 2,
                  text: "$ " + formatNumero(vlr50),
                  fontSize: 8,
                  alignment: "right",
                },
                "",
              ],
              [
                {
                  fontSize: 8,
                  colSpan: 3,
                  text: [
                    { text: "$20.000", style: "center", bold: false },
                  ],
                },
                "", "",
                {
                  colSpan: 2,
                  text: formatNumero(cant20),
                  fontSize: 8,
                  alignment: "right",
                },
                "",
                {
                  colSpan: 2,
                  text: "$" + formatNumero(vlr20),
                  fontSize: 8,
                  alignment: "right",
                },
                "",
              ],

              [
                {
                  fontSize: 8,
                  colSpan: 3,
                  text: [
                    { text: "$10.000", style: "center", bold: false },
                  ],
                },
                "", "",
                {
                  colSpan: 2,
                  text: formatNumero(cant10),
                  fontSize: 8,
                  alignment: "right",
                },
                "",
                {
                  colSpan: 2,
                  text: "$" + formatNumero(vlr10),
                  fontSize: 8,
                  alignment: "right",
                },
                "",
              ],
              [
                {
                  fontSize: 8,
                  colSpan: 3,
                  text: [
                    { text: "$5.000", style: "center", bold: false },
                  ],
                },
                "", "",
                {
                  colSpan: 2,
                  text: formatNumero(cant5),
                  fontSize: 8,
                  alignment: "right",
                },
                "",
                {
                  colSpan: 2,
                  text: "$" + formatNumero(vlr5),
                  fontSize: 8,
                  alignment: "right",
                },
                "",
              ],
              [
                {
                  fontSize: 8,
                  colSpan: 3,
                  text: [
                    { text: "$2.000", style: "center", bold: false },
                  ],
                },
                "", "",
                {
                  colSpan: 2,
                  text: formatNumero(cant2),
                  fontSize: 8,
                  alignment: "right",
                },
                "",
                {
                  colSpan: 2,
                  text: "$ " + formatNumero(vlr2),
                  fontSize: 8,
                  alignment: "right",
                },
                "",
              ],
              [
                {
                  fontSize: 8,
                  colSpan: 3,
                  text: [
                    { text: "$1.000", style: "center", bold: false },
                  ],
                },
                "", "",
                {
                  colSpan: 2,
                  text: formatNumero(cant1),
                  fontSize: 8,
                  alignment: "right",
                },
                "",
                {
                  colSpan: 2,
                  text: "$ " + formatNumero(vlr1),
                  fontSize: 8,
                  alignment: "right",
                },
                "",
              ],
              [
                {
                  fontSize: 8,
                  colSpan: 3,
                  text: [
                    { text: "Moneda", style: "center", bold: false },
                  ],
                },
                "", "",
                {
                  colSpan: 2,
                  text: " ",
                  fontSize: 8,
                  alignment: "center",
                },
                "",
                {
                  colSpan: 2,
                  text: "$ " + formatNumero(vlrmon),
                  fontSize: 8,
                  alignment: "right",
                },
                "",
              ],

              [
                {
                  colSpan: 5,
                  text: "Total Efectivo Entregado",
                  style: "right",
                  fontSize: 10,
                },
                "",
                "",
                "",
                "",
                {
                  colSpan: 2,
                  text: "$ " + formatNumero((totalefectivo) || 0),
                  fontSize: 8,
                  alignment: "right",
                },
                "",
              ],

              [
                {
                  colSpan: 5,
                  text: "Diferencia",
                  style: "right",
                  fontSize: 10,
                },
                "",
                "",
                "",
                "",
                {
                  colSpan: 2,
                  text: "$ " + formatNumero((diferencia) || 0),
                  fontSize: 8,
                  alignment: "right",
                },
                "",
              ],
              [
                {
                  colSpan: 7,
                  text: [
                    { text: "Observaciones:\n  ", bold: true },
                    data.observacion_cua.trim(),
                  ],
                  fontSize: 8,
                },
                "",
                "",
                "",
                "",
                "",
                "",
              ],


            ],
          },
          layout,
        },
      ],
      styles: {
        center: {
          bold: true,
          alignment: "center",
        },
        right: {
          bold: true,
          alignment: "right",
        },
      },
      // pageSize: {
      //   width: 300,
      //   height: "auto",
      // },
      // pageMargins: [10, 10, 10, 10],
    };

    pdfMake.createPdf(dd).open();
    res();
  });
};
export {
  tiquete_transporte,
  recibo_caja,
  cuadre_cajatr,
  remision,
  ordensal_sar,
  ordenCombustible,
  CompEgreso
};
